/**
 * Back to Top —— 保留 Dongqi 草稿主题现有行为。
 * 滚过一屏显示，点击后尊重 reduced-motion 回到页首。
 *
 * 🚨 点击用 window.scrollTo 而不是锚点：
 * 主题 theme.js 的页面过渡会代理所有 a[href] 并在 200ms 后强制导航
 * （无视 preventDefault，历史上 Size Guide 就栽过），用按钮 + JS 完全绕开。
 */
(function () {
  var SHOW_AFTER = 1;

  function button() {
    return document.querySelector('[data-amada-back-to-top]');
  }

  function sync() {
    var element = button();
    if (!element) return;
    var visible = window.pageYOffset > window.innerHeight * SHOW_AFTER;
    element.classList.toggle('is-visible', visible);
    element.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  var ticking = false;
  function onViewportChange() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      sync();
      ticking = false;
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('[data-amada-back-to-top]');
    if (!target) return;
    event.preventDefault();
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  });

  window.addEventListener('scroll', onViewportChange, { passive: true });
  window.addEventListener('resize', onViewportChange, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
